module.exports = __webpack_public_path__ + "app/modals/generic-confirmation-modal.view.html";